//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
// import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'Корпоративный Т1 Диск: настраиваем в прямом эфире',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Корпоративный Т1 Диск: настраиваем в прямом эфире',
  description: [
    '<i>«Коллеги, загрузили документ на диск, внесите, пожалуйста, правки в режиме редактирования»</i> — привычная рутина рабочих дней. И тут главное, чтобы решение был удобным. На вебинаре мы покажем работу нашего сервиса — T1 Диска.',
    'T1 Диск — облачный корпоративный сервис для организации файлового хранения, обмена данными и совместной работы с документами внутри компании и за её пределами. На вебинаре, в прямом эфире, продемонстрируем топ-5 функций, которые ускоряют и упрощают рабочий процесс:',
    '<ul><li><b>Выдача прав доступа:</b> управление пользователями, выдача частного доступа для коллег и внешних контрагентов, создание групп по задачам.</li><li><b>Совместная работа над файлами:</b> онлайн редактирование, создание папок, просмотр истории действий и версий документов.</li><li><b>Передача файлов:</b> перенос документов и материалов от сотрудника к сотруднику, передача внешних ссылок с паролем или без, а также возможность поделиться файлами внутри компании.</li><li><b>Синхронизация:</b> дублирование на ПК, доступ через WebDav, доступ через веб-версию и мобильное приложение.</li><li><b>Безопасность:</b> двукратное резервное копирование, шифрование данных, сохранение их внутри организации. </li></ul>',
    'До встречи на вебинаре 12 марта в 11:00!'
  ],
  date: '12.03.2024',
  time: '11:00'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'pGCfPsXJ',
          id: 2170,
          hallName: 'Первый зал' // название зала
        //   },
        //   {
        //     hash: 'PXBhAboi',
        //     id: 1106,
        //     hallName: 'Второй зал'
        }
      ]
    }
    // {
    //   tabName: '16.06.3023',
    //   items: [
    //     {
    //       hash: 'MAclQpGI',
    //       id: 1357,
    //       hallName: 'Третий зал'
    //     }
    //   ]
    // }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикер', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как пройти', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Этот блок состоит из текстового описания и картинки с пропорциями квадрата. Чаще всего мы сюда помещаем информацию о том, как добраться до места проведения мероприятия, что нужно с собой взять (например, паспорт).',
      'Можно добавить информацию о наличии парковочных мест.',
      'Можно дать ссылку на <a href="#" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'Контакты', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<a href="https://t.me/+yzZM8OmSvyQ4YzQ6"><img src="assets/logo/telegram.png" width="50" height="50" alt="Telegram"></a>&emsp;&emsp;<a href="https://vk.com/t1_cloud" target="_blank"><img src="assets/logo/vk.png" width="50" height="50" alt="Вконтакте"</img></a>&emsp;&emsp;<a href="https://www.youtube.com/@t1-cloud/featured" target="_blank"><img src="assets/logo/youtube.png" width="50" height="50" alt="YouTube"</img></a>&emsp;&emsp;<a href="https://t1-cloud.ru/" target="_blank"><img src="assets/logo/globe.png" width="50" height="50" alt="Сайт"</a>',
      '<a href="https://clck.ru/35rcis" target="_blank">Подписка на рассылку</a>'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
  //  items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
